import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getJepxMemberInfo } from '@ebalance/proto/bffuser/v1/jepx_member_info_service-JepxMemberInfoService_connectquery'
import {
  GetJepxMemberInfoRequestSchema,
  type GetJepxMemberInfoResponse,
} from '@ebalance/proto/bffuser/v1/jepx_member_info_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * JEPX 連携マスタ情報 (会員情報 + 料金・手数料) を 1 回で取得する (AC-IJM-001)。
 *
 * 会員情報は運営が登録する 1 組織 1 件の singleton で、 本画面は閲覧専用。
 * 未設定の組織では `memberInfo` が undefined で返る (AC-IJM-003)。
 */
export function useGetJepxMemberInfo(): UseQueryResult<
  GetJepxMemberInfoResponse,
  ConnectError
> {
  return useQuery(getJepxMemberInfo, create(GetJepxMemberInfoRequestSchema, {}))
}
